import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { QueryParam, QueryParams } from '@components/Filters/filter.types'
import { RootState } from '@store/store'

type TabFiltersState = {
  [K in keyof QueryParams]: { values: QueryParam }
}

const initialState: TabFiltersState = {}

const EMPTY_OBJECT: QueryParam = {}

const filterMetadataSlice = createSlice({
  name: 'filterMetadata',
  initialState,
  reducers: {
    setTabFilters: (
      state,
      action: PayloadAction<{ tab: keyof QueryParams; filters: QueryParams[keyof QueryParams] }>,
    ) => {
      const { tab, filters } = action.payload

      state[tab] = { values: { ...filters } }
    },

    resetTabFilters: (state, action: PayloadAction<keyof QueryParams>) => {
      delete state[action.payload]
    },

    resetAllTabFilters: () => initialState,
  },
})

export const selectTabFilters =
  (area: keyof QueryParams) =>
  (state: RootState): QueryParam =>
    state.filterMeta[area]?.values || EMPTY_OBJECT

export const { setTabFilters, resetTabFilters, resetAllTabFilters } = filterMetadataSlice.actions

export const filterMetadataReducer = filterMetadataSlice.reducer
